import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HomePage } from "../../home/home";
import * as firebase from 'firebase';
import { OrdersCoServices } from '../../orders/services';
import { AngularFireAuth } from 'angularfire2/auth';
import { TranslateService } from '@ngx-translate/core';
import { LoginPage } from '../login/login';
import { ConfigurationServices } from '../../configuration/services';

/**
 * Generated class for the SuperPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-multi,',
  templateUrl: 'multi.html',
})
export class MultiPage {

  firestore: any;
  restaurants: any;

  getMaxLinesNameStyle(): { [key: string]: any } {
    var maxLines = 1; // Define el número máximo de líneas que deseas mostrar
    return {
      'display': '-webkit-box',
      '-webkit-line-clamp': maxLines,
      '-webkit-box-orient': 'vertical',
      'overflow': 'hidden',
      'text-overflow': 'ellipsis',
    };
  }

  getMaxLinesAddressStyle(): { [key: string]: any } {
    var maxLines = 3; // Define el número máximo de líneas que deseas mostrar
    return {
      'display': '-webkit-box',
      '-webkit-line-clamp': maxLines,
      '-webkit-box-orient': 'vertical',
      'overflow': 'hidden',
      'text-overflow': 'ellipsis',
    };
  }

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public ordersCoServices: OrdersCoServices,
    public loadingCtrl: LoadingController,
    public afAuth: AngularFireAuth,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public translate: TranslateService,
    public configurationServices: ConfigurationServices) {

    this.getRestaurants();

    this.firestore = firebase.firestore();

  }

  async getRestaurants() {
    this.restaurants = await this.globals.getMultiRestaurants();
  }

  async openRestaurant(restaurant) {
    this.globals.restaurant_uid = restaurant.UID;
    this.globals.RESTAURANT_TAX = restaurant.tax_percentage;
    this.globals.user_name = restaurant.company;
    this.globals.user_email = restaurant.email;
    this.globals.user_rol = restaurant.user_rol;
    this.globals.user_type = 'multi';
    this.globals.waiter = restaurant.user_name_defwaiter;
    this.globals.waiter_uid = restaurant.user_uid_defwaiter;
    await this.globals.getRestaurant(this.globals.restaurant_uid);
    //await this.getWaiter();
    this.navCtrl.push(HomePage);

  }

  async getWaiter() {
    var users = await this.ordersCoServices.getAccessCodes();

    for (let user of users) {
      for (let restaurant of this.globals.objectToArray(user.restaurants)) {
        if (restaurant.UID_RESTAURANT == this.globals.restaurant_uid) {
          if (restaurant.rol == 'admin') {
            this.globals.waiter = user.name;
            this.globals.waiter_uid = user.UID;
          }
        }
      }
    }
  }

  logout() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('general-cerrar-sesion'),
      message: this.translate.instant('instant-seguro-quieres-cerrar-sesion'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.open_side_menu = false;
            this.delNotTokenAndLogout();
          }
        }
      ]
    });
    alert.present();
  }

  async delNotTokenAndLogout() {
    //funcion que borra token
    if (this.globals.token_user_uid && this.globals.token_current_user) {
      await this.configurationServices.deleteToken(this.globals.token_user_uid, this.globals.token_current_user);
    }
    //hacemos logout de afAuth
    this.afAuth.auth.signOut()
      .then(authData => {
        // toast message
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-cerrado-sesion'),
          duration: 3000,
          position: 'top'
        });
        toast.present();
        if (this.globals.user_type != 'principal' && this.globals.user_type != 'teacher') {
          this.globals.GAtrackView('Logout', 'Logout ', this.globals.restaurant.email, 'Logout', 'Logout', 'Logout', '');
        }

        this.navCtrl.setRoot(LoginPage);
        window.location.reload();
      }, error => {
        //var errorMessage: string = error.message;
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/multi/multi.ts